import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const isAuthenticatedQuery = gql`
  query isAuthenticatedQuery {
    isAuthenticated: isAuthenticatedV2
  }
`;

type Props = {
  skip?: boolean;
};

export const useIsAuthenticated = ({ skip }: Props = {}) => {
  const { data, error, loading } = useQuery(isAuthenticatedQuery, {
    skip,
  });

  return {
    error,
    isAuthenticated: Boolean(data?.isAuthenticated),
    isLoading: loading,
  };
};
